export const strToDate = (date) => {
  return new Date(date);
};
export const dateFormat = (date: Date, option = "") => {
  return option != ""
    ? date.toLocaleDateString(option)
    : date.toLocaleDateString();
};
